import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from 'react-hook-form';
import { EMAIL_REGEX } from '../../Constants';
import { SkywatchDialog } from '../PopUps/SkywatchDialog';
import FlexView from 'react-flexview/lib';
import NewButtonPopup from '../Core/Buttons/NewButtonPopup';
import { ElevatedCircle } from '../Core/ElevatedCircle';
import policymanagementApi from '../../api/policymanagement.api';
import { addDays, awaitWithLoading } from '../../services/utils';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { PolicyManagementContextStore, ACTIONS } from '../../context/PolicyManagementContext';
import { Action } from '../../models/Action';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { ActiveInsuranceModel } from '../../models/insurance-models/ActiveInsuranceModel';
import { RadioGroup, Radio, FormControlLabel,Select, MenuItem, Grid ,IconButton,InputAdornment,Checkbox,FormGroup,FormHelperText,Divider} from '@material-ui/core';
import policmanagementImpersonationApi from '../../api/policmanagement.impersonation.api';
import { BlueGrayBox } from "../Core/BlueGrayBox";
import { DatePicker } from '@material-ui/pickers'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import EventIcon from '@material-ui/icons/Event';
import {ModificationApi} from "../../api/modification.api"


export const LossPayeeEndorsementPopup = ({onCancel, insuranceId,onConfirm, open,fullRefund = false,policyStartDate }) => {
  const { register, errors, getValues, triggerValidation, control,setValue } = useForm()
  const context = React.useContext(PolicyManagementContextStore)
  const [isExtended, setIsExtended] = React.useState(false)
  const [selectedDate, setSelectedDate] = React.useState(new Date())
  const [isNotRefundReq,setIsNotRefundReq] = React.useState(fullRefund)
  const insurance: ActiveInsuranceModel = context.getInsurance(insuranceId)
  const getAllAdditionalInsuredList = context.allAdditionalInsuredList;
  const [insuredDrones,setInsuredDrones] = React.useState(insurance.insuredDroneList)
  const [insuredEquipments,setInsuredEquipment] = React.useState(insurance.insuredEquipmentList)
  const [selectedAdditionalInsured,setSelectedAdditionalInsured] = React.useState(getAllAdditionalInsuredList[0])
  const [incluedDrone, setIncluedDrone] = React.useState(insuredDrones.map(item => false))
  const handleClose = () => {
    onCancel && onCancel()
  };
  const handleExtended = () => {
    setIsExtended( !isExtended )
  }

  const onDateChanged = date =>{
      setSelectedDate(new Date(date))
  }

  React.useEffect(()=>{
      setInsuredDrones(insuredDrones.map(item=>{
        item.included = false 
        return item  
      }))
      setInsuredEquipment(insuredEquipments.map(item=>{
        item.included = false 
        return item  
      }))
  },[])


  const includeExcludDrone = index =>{
    let newSt = [...insuredDrones]
    newSt[index].included = !insuredDrones[index].included
    setInsuredDrones(newSt)
  }

  const includeExcludEquipment = index =>{
    let newSt = [...insuredEquipments]
    newSt[index].included = !insuredEquipments[index].included
    setInsuredEquipment(newSt)
  }
  const Confirm = async () => {
      let valid = await triggerValidation()

      if(!valid) return;
      const values = getValues();
      const additionalInsured = values['additional_insured']
      const drones = insuredDrones.filter(x=>x.included === true)
      const equipments = insuredEquipments.filter(x=>x.included === true)
      onConfirm && onConfirm({selectedAdditionalInsured,drones,equipments})
  }
  return (
      <SkywatchDialog
            open={open}
            closeDialog={handleClose}
            closeTitle="Additional Insured"
            maxWidth={'sm'}>
            {getAllAdditionalInsuredList.length>0 && insuredDrones.length>0 &&open&& <div className="full-width">
                <div className="modify-title blue">Generate Loss Payee Endorsement</div>
                <Grid container item xs={6} spacing={2}>
                    <Grid className="bold" item xs={12}>
                        Select Additional Insured
                    </Grid>
                    <Grid container item xs={12} >
                    <Controller control={control} 
                  name="additional_insured" 
                  defaultValue={selectedAdditionalInsured.name}
                  as={
                    <RadioGroup>
                        <FlexView column>
                        {getAllAdditionalInsuredList.map((x, index) => (
                            <FormControlLabel 
                            onChange={(e) => {
                                setSelectedAdditionalInsured(x)
                            }}
                            label={x.name} 
                            value={x.name} 
                            key ={x.id} 
                            control={<Radio color="primary" />} />
                        ))}
                        </FlexView>
                    </RadioGroup>} />       
                </Grid>
                </Grid>

                <Divider/>
                <Grid className="bold" item xs={12}>
                        Select Hull Item(s)
                    </Grid>
                    <Grid container item xs={12} >

                <Controller control={control} 
                  name="hull_items" 
                  as={<FormGroup>
                        {insuredDrones.map((item, index) => <FormControlLabel 
                            key={item.id}
                                label={`${item.make} ${item.model} ${item.serial}`}
                                control={<Checkbox 
                                checked={item.included} 
                                color="primary" 
                                inputRef={register}
                                name={item.model}
                                onChange={()=>includeExcludDrone(index)}
                                />}
                                />)}
                            {insuredEquipments.map((item, index) => <FormControlLabel 
                            key={item.id}
                                label={`${item.type} ${item.description} ${item.serial}`}
                                control={<Checkbox 
                                checked={item.included} 
                                color="primary" 
                                inputRef={register}
                                name={item.model}
                                onChange={()=>includeExcludEquipment(index)}
                                />}
                                />)}
                                </FormGroup>} />
                                  
                                     
                </Grid>
                {insuredDrones.every(x=>x.included === false) && insuredEquipments.every(x=>x.included === false) &&  (
                    <FormHelperText error>
                        Please select at least one option
                    </FormHelperText>
                )}
                
                
                <FlexView vAlignContent={'center'} className="space-between actions-footer">
                    <NewButtonPopup withFill={false} onClick={handleClose}>Close</NewButtonPopup>
                    <NewButtonPopup withFill={true} onClick={async ()=>{Confirm()}}>Generate Endorsement</NewButtonPopup>
                </FlexView>
            </div>}
        </SkywatchDialog>
  );
}